// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".register-layout[data-v-9e5e0a7c] {\n  overflow-x: hidden;\n}\n@media (max-width: 768px) {\n.register-layout[data-v-9e5e0a7c] {\n    padding-bottom: 60px;\n}\n}", ""]);
// Exports
module.exports = exports;
